import featureUpgrade from './featureUpgrade.js';
import { Router } from '@/legacy/Router';

Router.get('feature-disabled/([a-z\\_A-Z0-9\\.]+)', featureUpgrade);
